import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { REQUIRES_SECURITY_PROFILE } from '../../interceptors/security-profile-auth-token.interceptor';
import { APP_ENV } from 'apps/cmg-clear2-ui/src/environments/environment.model';

@Injectable({ providedIn: 'root' })
export class DocumentUpload34Service {
  environment = inject(APP_ENV);
  private readonly _httpClient = inject(HttpClient);

  uploadDocuments(payload): Observable<any> {
    return this._httpClient.post<any>(`${this.environment.retail.apiUrl}/upload34/upload`, payload, {
      context: new HttpContext().set(REQUIRES_SECURITY_PROFILE, true),
    });
  }

  validateMismo(payload): Observable<any> {
    return this._httpClient.post<any>(`${this.environment.retail.apiUrl}/upload34/validate`, payload, {
      context: new HttpContext().set(REQUIRES_SECURITY_PROFILE, true),
    });
  }
}
